module.exports = __webpack_public_path__ + "img/ivana_la_tyczhr54ddk_4WwPr.5b789009.jpg";